<template>
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="8">
        <ion-chip :color="quizItem._answer ? 'success':'secondary'">
          <ion-label>{{quizItem.order}}</ion-label>
          <ion-icon v-if="quizItem._answer" :icon="checkmarkCircleOutline"></ion-icon>
        </ion-chip>
        <span style="font-size:medium">{{quizItem.title}}</span>
        <ion-icon v-if="quizItem.detail || quizItem.tip" v-on:click="showToast()" style="padding-left: 3px" :icon="informationCircleOutline"></ion-icon>
      </ion-col>
      <ion-col>
        <ion-input v-if="isDesktop()" type="date" style="color: var(--ion-color-secondary)"   v-model="answer" v-on:ionChange="dataChanged()" placeholder="Select Date"></ion-input>
        <ion-datetime v-else style="color: var(--ion-color-secondary)"  :max="maxAgeYear"
                      v-model="answer"  v-on:ionChange="dataChanged()" placeholder="Select Date" ></ion-datetime>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonChip,
  IonIcon,
  IonLabel,
  IonDatetime,
  IonInput,
  isPlatform
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  informationCircleOutline
} from 'ionicons/icons';

import eoppService from "@/mixins/EoppService";

export default {
  name: 'QuizItemDob',
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonChip,
    IonIcon,
    IonLabel,
    IonDatetime,
    IonInput
  },
  mixins: [eoppService],
  data() {
    return {
      checkmarkCircleOutline,
      informationCircleOutline,
      answer: null,
      options:[]
    };
  },
  computed :{
    maxAgeYear() {
      const dt = new Date();
      dt.setFullYear( dt.getFullYear() - this.quizItem.minage);
      return dt.getFullYear();
    }
  },
  mounted() {

    this.initPreviousAnswer();
  },
  props: {
    quizItem: {
      type: Object,
      required: false
    }
  },
  methods: {
    initPreviousAnswer: function () {
      const prev = this.getPrevQuizItem(this.quizItem.code);
      if (prev) {
        this.answer = prev._answer;
      }
    },
    showToast: function () {
      // this.messageService.toast(this.quizItem.detail, this.quizItem.tip);
    },
    dataChanged: function () {
      this.$emit('answer', this.answer);
    },
    isDesktop: function () {
      return isPlatform('desktop');
    },
  }
}
</script>
<style>
ion-select {
  max-width: 100%;
  /*background-color: #bbb;*/
  color: var(--ion-color-secondary);
  border: thin solid var(--ion-color-secondary);
  /*border: thin solid red;*/
  border-radius: 10px;
}

/*.default-select {*/
/*  color: var(--ion-color-secondary);*/
/*  border: thin solid var(--ion-color-secondary);*/
/*  border-radius: 10px;*/
/*  padding-left: 1em;*/
/*  min-width: 100%;*/
/*}*/

.completed-quiz {
  color: var(--ion-color-success);
  border: thin solid var(--ion-color-success);
  border-radius: 10px;
}

/*.completed-quiz-bg {*/
/*  background: var(--ion-color-success);*/
/*  border: thin solid var(--ion-color-success);*/
/*}*/
</style>
